import React, { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CSVLink } from 'react-csv';
import html2pdf from 'html2pdf.js';


const Step4ProductList = ({ wallWidth, products, vanityPlacement, selectedVariant, onBack, onRestart }) => {
  const [groupedData, setGroupedData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const exportRef = useRef();

  const getProductImage = (product) => {
    const media = product._embedded?.['wp:featuredmedia']?.[0];
    return (
      media?.media_details?.sizes?.medium?.source_url ||
      media?.media_details?.sizes?.large?.source_url ||
      media?.media_details?.sizes?.full?.source_url ||
      media?.source_url || ''
    );
  };

  useEffect(() => {
    if (!products || products.length === 0) return;

    const productMap = new Map();

    products.forEach((product) => {
      const model = product.title.rendered;
      const width = product._embedded?.['wp:term']?.flat().find(t => t.taxonomy === 'width')?.name || 'N/A';
      const style = product._embedded?.['wp:term']?.flat().find(t => t.taxonomy === 'style')?.name || 'N/A';
      const omsid = product.acf?.oms_id || 'N/A';
      const image = getProductImage(product);
      const key = `${model}_${width}_${style}_${omsid}`;

      if (productMap.has(key)) {
        productMap.get(key).quantity += 1;
      } else {
        productMap.set(key, {
          quantity: 1,
          model,
          width,
          style,
          omsid,
          image
        });
      }
    });

    // Add filler and toe kick once based on vanity placement
    const variantSlug = selectedVariant?.slug?.toUpperCase() || 'SDV';

    if (vanityPlacement === 'one-wall' || vanityPlacement === 'two-walls') {
      const fillerCount = vanityPlacement === 'one-wall' ? 1 : 2;
      const fillerModel = `KAFS330-${variantSlug}`;
      const fillerKey = `${fillerModel}_N/A_Filler_Auto-Generated`;
      

      if (!productMap.has(fillerKey)) {
        productMap.set(fillerKey, {
          quantity: fillerCount,
          model: fillerModel,
          width: '1"',
          style: 'Filler',
          omsid: 'Auto-Generated',
          image: ''
        });
      }
    }

    const toeKickModel = `KATK96-${variantSlug}`;
    const toeKickKey = `${toeKickModel}_N/A_Toe Kick_Auto-Generated`;

    const toeQty = wallWidth > 90 ? 2 : 1;     // ← 90″ threshold

    if (productMap.has(toeKickKey)) {
      productMap.get(toeKickKey).quantity = toeQty;
    } else {
      productMap.set(toeKickKey, {
        quantity: toeQty,
        model: toeKickModel,
        width: '90.5"',
        style: 'Toe Kick',
        omsid: 'Auto-Generated',
        image: '',
      });
    }

    const grouped = Array.from(productMap.values());
    setGroupedData(grouped);

    setCsvData(grouped.map(item => ({
      Quantity: item.quantity,
      Model: item.model,
      Width: item.width,
      Style: item.style,
      OMSID: item.omsid,
      Image: item.image
    })));
  }, [wallWidth, products, vanityPlacement, selectedVariant]);

  const handlePrint = () => {
    window.print();
  };

  const handlePDFDownload = () => {
    const element = exportRef.current;
    html2pdf().from(element).set({
      margin: 0.5,
      filename: 'cabinet-product-list.pdf',
      html2canvas: { scale: 2 },
      jsPDF: { format: 'a4', orientation: 'portrait' },
    }).save();
  };

  return (
    <div className="pb-4" ref={exportRef}>
      
            <div class="section-heading">
                    <h2>Product List</h2>
                    <p>Download or print your product list and take it to your Home Depot designer.</p>
                </div>
      {/* Product Images */}
      <div className="d-flex flex-wrap justify-content-center gap-4 mb-5">
        {products.map((product, idx) => (
          <div key={idx} className="product-thumbnail">
            <img
              src={getProductImage(product)}
              alt={product.title.rendered}
              className=""
            />
            <div className="mt-2 small text-muted">{product.title.rendered}</div>
          </div>
        ))}
      </div>

      {/* Grouped Table */}
      
      <div className="table-responsive mt-4">
        <table className="product-list">
          <thead className="">
            <tr>
              {/* <th>Image</th> */}
              <th>Quantity</th>
              <th>Model #</th>
              <th>Width</th>
              <th>Style</th>
              
            </tr>
          </thead>
          <tbody>
            {groupedData.map((item, idx) => (
              <tr key={idx}>
                {/* <td>
                  {item.image ? (
                    <img
                      src={item.image}
                      alt={item.model}
                      style={{ maxWidth: '80px', maxHeight: '80px', objectFit: 'contain' }}
                    />
                  ) : (
                    <span className="text-muted small">No Image</span>
                  )}
                </td> */}
                <td className="fw-bold">{item.quantity}</td>
                <td className="text- fw-medium">{item.model}</td>
                <td>{item.width === 'N/A' ? item.width : `${item.width}`}</td>
                <td>{item.style}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
        <div className="containerx">
        <div className="d-flex justify-center text-center mb-5">
          <div className="col-sm-12 col-md-6 col-lg-10">

        <strong>Note&nbsp;—</strong> When a vanity sits directly against a side wall, <em>at least one filler</em> is required for proper door / drawer clearance. The necessary filler(s) have already been added to the product list above.
          </div>
        </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="fixed-footer">
      <div class="step-buttons">
        <button className="button back" onClick={onBack}>← Back</button>
        <button className="button back" onClick={onRestart}>Restart</button>
        {/* <CSVLink data={csvData} filename="cabinet-configurator-summary.csv" className="btn btn-success">
          Export to CSV
        </CSVLink> */}
        <button className="button next" onClick={handlePDFDownload}>Export to PDF</button>
        <button className="button next" onClick={handlePrint}>🖨 Print</button>
        
      </div>
      </div>
    </div>
  );
};

export default Step4ProductList;
